<div class="panel">
  <h2>Infos Blockchain</h2>

  <div class="form-group">
    <label for="id">Plage</label>
    <span id="id" class="value">{{ entity.blockAddress.strandId }}</span>
  </div>

  <div class="form-group">
    <label for="id">Numéro de séquence</label>
    <span id="id" class="value">{{ entity.blockAddress.sequenceNo }}</span>
  </div>
</div>